import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const PageHelpOverrideContext = createContext(null);

export function PageHelpOverrideProvider({ children }) {
  const [override, setOverrideState] = useState(null);

  const setOverride = useCallback((value) => {
    setOverrideState(value);
  }, []);

  const value = useMemo(
    () => ({ override, setOverride }),
    [override, setOverride]
  );

  return (
    <PageHelpOverrideContext.Provider value={value}>
      {children}
    </PageHelpOverrideContext.Provider>
  );
}

export function usePageHelpOverride(override) {
  const ctx = useContext(PageHelpOverrideContext);

  React.useEffect(() => {
    if (!ctx) return undefined;
    ctx.setOverride(override ?? null);
    return () => ctx.setOverride(null);
  }, [ctx, override]);
}

export function usePageHelpOverrideValue() {
  return useContext(PageHelpOverrideContext)?.override ?? null;
}
